import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import style from './style.module.less';
import { useUserDateFormat } from '../../../../../hooks/use-datetime-formats';

const TooltipLable = ({ selectedDate }) => {
  const { formatUserDate } = useUserDateFormat();
  const formatTooltipLabel = useCallback(
    (date) => {
      const momentDate = moment(date);
      return formatUserDate(momentDate);
    },
    [formatUserDate],
  );
  return <div className={style.content}>{formatTooltipLabel(selectedDate)}</div>;
};

TooltipLable.propTypes = {
  selectedDate: PropTypes.string,
}.isRequired;

export default TooltipLable;
